var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{ref:"header"}),_c('div',{staticClass:"iframe-wrapper"},[(_vm.isFrameLoaded)?_c('Loader'):_vm._e(),_c('div',{attrs:{"id":"frame"}},[_c('iframe',{ref:"iframe",attrs:{"id":"iframe"}})])],1),_c('Footer',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }